import React, { FC } from 'react';
import Button, { ButtonProps } from '../../../../Common/Button/Button';
import ButtonIcon from '../../../../../assets/icons/inline/arrow-top-right-light.inline.svg';
import * as classes from './DefaultButton.module.scss';

interface Props extends ButtonProps {
  withoutIcon?: boolean;
}

const DefaultButton: FC<Props> = ({ children, withoutIcon, ...props }) => {
  if (withoutIcon) {
    return (
      <Button {...props} className={classes.button}>
        <div className={classes.text}>{children}</div>
        <div className={classes.icon}>
          <ButtonIcon />
        </div>
      </Button>
    );
  }

  return (
    <Button {...props} icon={<ButtonIcon />} className={classes.buttonWithIcon}>
      {children}
    </Button>
  );
};

export default DefaultButton;
